import templateUrl from './in-the-news-details.html';

export const inTheNewsDetailsComponent = {

	//binding details
	bindings: {
		details: '<',
        parentSlug: '@',
        slugUrl: '@'
	},

	templateUrl,

	//controller for InTheNewsDetailsComponent
	controller: class InTheNewsDetailsComponent {
        constructor($state, $sce, AboutUsService) {
            'ngInject';

            this.$state = $state;
            this.$sce = $sce;
            this.aboutUsService = AboutUsService;
        }

        $onInit() {
            this.details = this.aboutUsService.getNewsDetailsById(this.details);
            this.details.description = this.$sce.trustAsHtml(this.details.description);
        }

        onGoBack() {
            this._redirectToParentState(this.parentSlug);
        }

        onEdit(id) {
            const url = this._getEditNewsSlugUrl();
            this._redirectToParentState(url);
        }

        _getEditNewsSlugUrl() {
            return this.slugUrl.replace('/details', '/edit');
        }

        _redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}
    }
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/in-the-news/in-the-news-details/in-the-news-details.component.js